import {
  Bot, Terminal, GitBranch, GitCommitVertical,
  FileText, FileEdit, PlugZap, GitFork, CircleDot,
} from 'lucide-react'
import type { ComponentProps } from 'react'

const iconMap: Record<string, typeof Bot> = {
  'claude-code': Bot,
  'run-command': Terminal,
  'git-clone': GitBranch,
  'git-commit-push': GitCommitVertical,
  'fetch-work-item': FileText,
  'create-change-set': FileEdit,
  'apply-change-set': GitCommitVertical,
  'validate-connector': PlugZap,
  'evaluate-condition': GitFork,
}

export function NodeTypeIcon({ type, ...props }: { type: string } & ComponentProps<typeof Bot>) {
  const Icon = iconMap[type] ?? CircleDot
  return <Icon {...props} />
}
